import { useTranslation } from "react-i18next";

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section id="cta" className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[600px]">
      <div className="lg:w-1/2 bg-secondary-100 relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20editorial%20with%20flowing%20designer%20garments%20suspended%20artistically%20in%20bright%20white%20studio%2C%20dramatic%20soft%20shadows%2C%20high-end%20brand%20campaign%20photography%2C%20elegant%20contemporary%20composition&width=900&height=700&seq=cta-v2-product&orientation=portrait"
          alt="Hipobuy Spreadsheet optimisez résultats"
          title="Hipobuy Spreadsheet - Optimisez Vos Résultats"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute bottom-0 left-0 p-8 md:p-12">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white leading-tight drop-shadow-lg">
            {t("cta.title.line1")}
            <br />
            {t("cta.title.line2")}
            <br />
            {t("cta.title.line3")}
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-6 py-16 md:py-20">
        <div className="max-w-sm text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            {t("cta.heading")}
          </h2>
          <p className="mt-5 text-foreground-600 text-sm leading-relaxed">
            {t("cta.description")}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-foreground-900 text-white text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap"
          >
            {t("cta.button")}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}